import { MEGA_BROKER_API } from '@tencent/mega-ipc-shared';
export const useMegaBroker = () => window[MEGA_BROKER_API];
//# sourceMappingURL=broker.js.map